
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { ThemeSupa } from '@supabase/auth-ui-shared';
import Image from 'next/image';
import Link from 'next/link';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import useLocale from 'next-translate/useTranslation';
import { useEffect, useState } from 'react';
import { useLocalStorage } from 'react-use';
// @supabase/auth-ui-react bundles its own copy of react-dom, which collides
// with React 19 at prerender time. Load it client-only.
const Auth = dynamic(() => import('@supabase/auth-ui-react').then((m) => m.Auth), { ssr: false });
import Seo from '@/components/Seo';
import { createClient } from '@/utils/supabase/component';
import { useUser } from '@/utils/useUser';
export default function Signup() {
    const supabase = createClient();
    const router = useRouter();
    const { asPath } = useRouter();
    const { user } = useUser();
    const { price, avatar, invite_code, join, headshots_join } = router.query;
    const [, setPriceValue] = useLocalStorage('price');
    const [, setAvatarValue] = useLocalStorage('avatar');
    const [, setInviteCodeValue] = useLocalStorage('invite_code');
    const [, setJoinValue] = useLocalStorage('join');
    const [, setHeadshotsJoinValue] = useLocalStorage('headshots_join');
    const [hash, setHash] = useState('');
    const { t, lang } = useLocale('common');
    useEffect(() => {
        // Redirect to login page with sign-up mode
        router.push('/login#auth-sign-up');
    }, [router]);
    useEffect(() => {
        setHash(asPath.split('#')[1]);
    }, [asPath]);
    useEffect(() => {
        if (price)
            setPriceValue(price);
    }, [price, setPriceValue]);
    useEffect(() => {
        if (avatar)
            setAvatarValue(avatar);
    }, [avatar, setAvatarValue]);
    useEffect(() => {
        if (invite_code)
            setInviteCodeValue(invite_code);
    }, [invite_code, setInviteCodeValue]);
    useEffect(() => {
        if (join)
            setJoinValue(join);
    }, [join, setJoinValue]);
    useEffect(() => {
        if (headshots_join)
            setHeadshotsJoinValue(headshots_join);
    }, [headshots_join, setHeadshotsJoinValue]);
    useEffect(() => {
        if (user)
            router.push('/dashboard');
    }, [user, router]);
    return (<div className='flex h-screen min-h-full items-center justify-center px-4 py-12 dark:bg-slate-900 sm:px-6 lg:px-8'>
      <Seo templateTitle={t('Sign up')}/>
      <div className='w-full max-w-md space-y-8'>
        <div>
          <Link href='/' className='' passHref legacyBehavior>
            <span className='flex justify-center text-2xl font-extrabold text-primary-700'>
              <Image src='/images/marky.png' width='250' height='36' alt='Easy-Peasy.ai logo'/>
            </span>
          </Link>
          <h2 className='mt-6 text-center text-3xl font-extrabold text-gray-900 dark:text-slate-200'>
            {t('Sign up')}
          </h2>
          <p className='mt-2 text-center text-sm text-gray-600'></p>
        </div>
        <Auth providers={['google', 'facebook']} supabaseClient={supabase} socialLayout='vertical' appearance={{ theme: ThemeSupa }} redirectTo={`${lang !== 'en'
            ? `https://easy-peasy.ai/${lang}/login/`
            : 'https://easy-peasy.ai/login/'}`} view='sign_up'/>
      </div>
    </div>);
}

    async function __Next_Translate__getStaticProps__1a11b03d527__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/signup',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a11b03d527__ as getStaticProps }
  